<template>
	<div class="header">
		<div class="left">
			<span>机台：{{ jtName }}</span>
			<span>质检员：</span>
			<span>批次：{{ batchName }}</span>
			<span>产品名称：{{ productName }}</span>
		</div>

		<div class="right">
			<!--版面-->
			<div class="left" style="margin-right: 10px;margin-top: -1px;">
				<button :class="{ sufaceBtn: true, active: selectedSideIndex == item.value }" v-for="(item, index) in surfacelist" :key="index" @click="changeModelSide(item.value)">{{ item.text }}</button>
			</div>
			<div class="right">
				<label for="topbar_show_rule_bar">
					<input type="checkbox" id="topbar_show_rule_bar" v-model="ruleBarVisible" />
					显示标尺
				</label>
				<label for="topbar_show_defect_point">
					<input type="checkbox" id="topbar_show_defect_point" v-model="defectPointVisible" />
					缺陷点
				</label>
			</div>
		</div>
		<div style="clear:both;"></div>
	</div>
</template>

<script>
	import { store } from './store'
	export default {
		data() {
			return {
				defectPointVisible: false,
				ruleBarVisible: true,
			}
		},
		computed: {
			/**
			 * 版面集合。
			 */
			surfacelist() {
				var list = []
				var modelSides = store.state.modelSides
				if (modelSides) {
					modelSides.forEach((v, i) => {
						console.log('modelsides', v)
						list.push({
							value: v.side_index,
							text: v.name,
						})
					})
				}

				return list.sort((a, b) => {
					return a.value - b.value
				})
			},
			/**
			 * 机台名称。
			 */
			jtName() {
				return store.state.jtName
			},
			/**
			 * 批次号。
			 */
			batchName() {
				return store.state.rollCode
			},
			/**
			 * 产品名称。
			 */
			productName() {
				return store.state.productName
			},
			/**
			 * 当前选择的版图。
			 */
			selectedSideIndex() {
				return store.state.modelSideIndex
			},
		},
		watch: {
			/**
			 * 监控缺陷点显示状态。
			 */
			defectPointVisible(val) {
				store.setDefectPointVisible(val)
			},
			/**
			 * 监控标尺显示状态。
			 */
			ruleBarVisible(val) {
				store.setRuleBarVisible(val)
			},
		},
		methods: {
			/**
			 * 切换版面。
			 */
			changeModelSide(index) {
				store.setModelSideIndex(index)
			},
		},
		created() {},
	}
</script>

<style lang="less" scoped>
	.left {
		float: left;
	}

	.right {
		float: right;
		font-size: 12px;
	}

	.header {
		background-color: #eeeeee;
		height: 25px;
		padding: 5px 10px 0 10px;
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		z-index: 9;

		span {
			margin-right: 10px;
			font-size: 12px;
		}
	}

	.sufaceBtn {
		font-size: 12px;
		height: 20px;
		margin-left: 5px;
		font-family: inherit;
		border: none;
		background-color: #eee;
		padding: 0 10px;
	}

	.sufaceBtn.active {
		color: #0008ff;
		font-weight: bold;
	}
</style>
